import { useParams } from 'react-router-dom';

import { Chip } from './chip';
import { Icon } from './icon';
import { useGetSubset } from '../../api/queries/useGetSubset';
import { CHIP_COLOURS } from '../lib/chip-colours';
import { cn } from '../lib/utils';

export function SubsetChip({ subsetId, className }: { subsetId: string; className?: string }) {
  const { matterId } = useParams();
  
  const { data } = useGetSubset(matterId, subsetId);
  if (!data || data?.isAllDocuments) return null;

  return (
    <Chip className={cn(CHIP_COLOURS.subset, 'border', className)}>
      <Icon className="lucide--group" />
      {data.name}
    </Chip>
  );
}
